import type { AuthenticationUser } from '@codezo/graphql';
import type { VetterUserType } from '../hooks/useAuth';

export function formatLoginUser(user: AuthenticationUser): VetterUserType {
	return {
		id: user.id,
		email: user.email ?? '',
		role: user.role,
		vetterUser: user.vetterUser
			? {
					vetterEntityId: user.vetterUser.vetterEntityId,
					firstName: user.vetterUser.firstName,
					lastName: user.vetterUser.lastName,
				}
			: null,
	};
}
